import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { DiscountOnRemoveModalProps } from 'reactApp/ui/DiscountOnRemoveModal/DiscountOnRemoveModal';

export enum DiscountOnRemoveActions {
    close = 'close',
    cancel = 'cancel',
    buy = 'buy',
}

export const renderDiscountOnRemoveModal = ({ onClose, ...data }: DiscountOnRemoveModalProps) =>
    openPopupHelper({ popupName: popupNames.DISCOUNT_ON_REMOVE_MODAL, data, onClose });

export const closeDiscountOnRemoveModal = () => closePopupHelper(popupNames.DISCOUNT_ON_REMOVE_MODAL);
